<form [formGroup]="formGroup" form="user-select-form">

  <h3 mat-dialog-title i18n>Create a booking for another user</h3>

  <div mat-dialog-content>
    <div [ngSwitch]="state">
      <div *ngSwitchCase="STATES.INITIAL">
        <p i18n>Select a user to create the booking for</p>
        <eas-user-select formControlName="user"></eas-user-select>
      </div>
      <div *ngSwitchCase="STATES.CONFIRMATION">
        <p i18n>
          You are about to create a booking for:
        </p>
        <p>
          {{ applyInfo.user.firstName }}
          {{ applyInfo.user.lastName }}
          ({{ applyInfo.user.email }})
        </p>
        <ub-label>
          <span text>
            <span *ngIf="applyInfo.eligibility.overall" class="met" i18n>User is eligible</span>
            <span *ngIf="!applyInfo.eligibility.overall" class="unmet" i18n>
              User is not Eligible
            </span>
          </span>
        </ub-label>
        <ub-label *ngIf="!applyInfo.eligibility.overall"
          label="Reason" i18n-label>
          <span text [innerHtml]="applyInfo.eligibility.reason"></span>
        </ub-label>
        <p i18n>Do you want to apply anyway?</p>
      </div>
      <div *ngSwitchCase="STATES.PROGRESS">
        <p i18n>
          Working...
        </p>
      </div>
      <div *ngSwitchCase="STATES.APPLIED">
        <p i18n>
          New booking has been successfully created.
        </p>
      </div>
      <div *ngSwitchCase="STATES.ERROR">
        <ub-alert *ngIf="error" variant="danger">
          <span message [innerText]="error"></span>
        </ub-alert>
      </div>
      <div *ngSwitchCase="STATES.WARNING">
        <ub-alert *ngIf="error" variant="warn">
          <span message [innerText]="error"></span>
        </ub-alert>
      </div>
    </div>
  </div>

  <div mat-dialog-actions>
    <eas-buttons-list [buttons]="buttons"></eas-buttons-list>
  </div>
</form>
